import {createLogger} from '@pexip/logger';
import {setLogger as setMediaComponentsLogger} from '@pexip/media-components';

const rootLogger = createLogger();

export const logger = rootLogger.child({name: 'branding'});

setMediaComponentsLogger(logger);
